angular.module("tableContract.components", []).component("tableContract", {
    templateUrl: "ng/components/gestioneQva/tableContract/tableContract.view.html",
    bindings: {
      filter: '<',
      listContract: "<",
      contrattoSelected: "&",
      isPending: "="
    },
    controllerAs: "tableContractCtrl",
    controller: function TableContract(
      $financialApiService,
      $location,
      $transactionFactory,
      RichiestePostVendita
    ) {
      var self = this;
  
      self.$onInit = function () {
        self.supportModel = {
          listContract: [],
          loaderDettaglio: []
        }
      };
  
      self.$onChanges = function (changes) {
      }
  
      self.onCheckboxChange = function (el) {
        el.selected = !el.selected;
        self.contractSelected = el.selected ? el : null;

        self.contrattoSelected({contratto: self.contractSelected});
    }
    
}
  })